import React, { useState } from 'react';
import { Section } from '@carbon/react';
import { useTheme } from '../contexts/ThemeContext';
import PageContainer from '../components/PageContainer';
import EmployeesTable from '../components/EmployeesTable';
import AdminShiftCalendar from '../components/AdminShiftCalendar';
import './Employees.css';

const TABS = [
  { id: 'general', label: 'Zaposleni' },
  { id: 'shifts', label: 'Smene / Raspored' },
];

const Employees = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'g100';
  const [activeTab, setActiveTab] = useState('general');

  return (
    <PageContainer>
      <Section style={{
        padding: 0,
        maxWidth: '100%',
        margin: 0,
        height: '100%'
      }}>
        <div style={{
          padding: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Navigation Tabs */}
          <nav className="emp-page-tabs" aria-label="Sekcije zaposlenih">
            <div className="emp-page-tabs__list" role="tablist" aria-label="Sekcije zaposlenih">
              {TABS.map((tab) => (
                <button
                  key={tab.id}
                  role="tab"
                  id={`emp-page-tab-${tab.id}`}
                  aria-selected={activeTab === tab.id}
                  aria-controls={`emp-page-panel-${tab.id}`}
                  tabIndex={activeTab === tab.id ? 0 : -1}
                  className={`emp-page-tab ${activeTab === tab.id ? 'emp-page-tab--active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </nav>

          {/* Content Area */}
          <main
            id={`emp-page-panel-${activeTab}`}
            className="emp-page-main"
            role="tabpanel"
            aria-labelledby={`emp-page-tab-${activeTab}`}
          >
            {activeTab === 'general' && <EmployeesTable />}
            {activeTab === 'shifts' && <AdminShiftCalendar />}
          </main>
        </div>
      </Section>
    </PageContainer>
  );
};

export default Employees;
